export class TmsData {
    public trackedPage?: string;
    public trackingArea: string;
    public trackingName: string;
    public targetUrl?: string;
    public trackingDisplayUniverse?: string;
    public trackingPageTitle?: string;
    public additionalProperties?: Map<string, string>;

    public constructor(init?: Partial<TmsData>) {
        Object.assign(this, init);
    }
}
